// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dNrI","colMin":"styles_colMin__1YGQT"};